<script lang="ts">
	import { BadgeCheckIcon, FireIcon } from '@rgossiaux/svelte-heroicons/outline'
	import type { Profile } from '$lib/types/profile'
	import { profile as userProfile } from '$lib/stores/userData'

	export let showBadge = true

	export let size = 0

	export let profile: Profile | undefined = undefined
	export let src: string | undefined = undefined

	$: accountType = profile?.accountType ?? $userProfile?.accountType
	$: badgeType = profile?.badgeType ?? $userProfile?.badgeType

	const metrics = [
		{
			size: 'xs',
			pfp: '2.4rem',
			badge: '1.2rem',
			pixels: 2.2 * 16,
			badgeOffset: '-0.3rem'
		},
		{
			size: 's',
			pfp: '3rem',
			badge: '1.3rem',
			pixels: 3 * 16,
			badgeOffset: '-0.4rem'
		},
		{
			size: 'm',
			pfp: '6rem',
			badge: '1.8rem',
			pixels: 6 * 16,
			badgeOffset: '-0.1rem'
		},
		{
			size: 'l',
			pfp: '12rem',
			badge: '2.5rem',
			pixels: 12 * 16,
			badgeOffset: '0.5rem'
		},
		{
			size: 'xl',
			pfp: '16rem',
			badge: '2.5rem',
			pixels: 16 * 16,
			badgeOffset: '0.5rem'
		},
		{
			size: 'xxl',
			pfp: '40rem',
			badge: '2.5rem',
			pixels: 40 * 16,
			badgeOffset: '0.5rem'
		},
	]
</script>

{#if $userProfile}
	<div class="relative">
		<div class="select-none flex items-center justify-center cursor-pointer overflow-hidden">
			<img
				style:height={metrics[size].pfp}
				style:width={metrics[size].pfp}
				src={src ?? profile?.pfp ?? $userProfile.pfp ?? '/profile-silhouette.jpg'}
				class="object-cover rounded-full pfp"
				alt="pfp"
			/>
		</div>
		{#if showBadge && badgeType}
			<div
				style:top={metrics[size].badgeOffset}
				style:right={metrics[size].badgeOffset}
				style:height={metrics[size].badge}
				style:width={metrics[size].badge}
				class="absolute rounded-full overflow-hidden"
			>
				{#if badgeType === 'admin'}
					<BadgeCheckIcon class=" text-white bg-blue-500" />
				{:else if badgeType === 'OG'}
					<FireIcon class=" text-white bg-app-500" />
				{:else if badgeType === 'verified'}
					<BadgeCheckIcon class=" text-white bg-app-500" />
				{:else if badgeType === 'paid' || accountType === 'paid'}
					<BadgeCheckIcon class=" text-white bg-green-500" />
				{/if}
			</div>
		{/if}
	</div>
{/if}

<style>
</style>
